export default __webpack_public_path__ + "static/media/sessions_bot_notify.ff1d7c92.jpg";